// Our base component, which all others extend.
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-breadcrumbs.css.lit';
import '../tufts-container/tufts-container';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';

/**
 * The Tufts  Breadcrumbs component
 * @element outline-breadcrumbs
 * @extends OutlineElement
 *
 * @slot breadcrumb - The default slot for this element.
 */

@customElement('tufts-breadcrumbs')
export class tuftsBreadcrumbs extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  ngSlot = new SlotNGController(this);
  clonedSlot: Node;
  listItems: NodeListOf<Element>;
  resizeController: ResizeController = new ResizeController(this);

  initializeData() {
    const slotCheck = this.querySelector('[slot]') as HTMLElement;
    /* Exits if no data exists in slot */
    if (!slotCheck) {
      return null;
    }
    this.clonedSlot = slotCheck.cloneNode(true);
    this.listItems = slotCheck.querySelectorAll('li');
    /* Breadcrumbs should not be displayed when it only includes current page */
    if (this.listItems.length < 1) {
      return null;
    }
    return true;
  }

  mainTemplate(): TemplateResult {
    /* Returns full list if content can fit in container */

    if (this.resizeController.currentBreakpointRange !== 0) {
      return html` ${this.clonedSlot}`;
    }
    /* Variables for finding the previous page
    Applying class for special styles for smaller container size */
    const previousPage = this.listItems[this.listItems.length - 1];
    const mobileBreadcrumb = previousPage.querySelector('a');
    const clonedLink = mobileBreadcrumb?.cloneNode(true) as HTMLElement;
    clonedLink!.classList.add('previous-page');
    return html` ${clonedLink} `;
  }

  render(): TemplateResult {
    if (this.initializeData()) {
      return html`
        <nav class="tufts-breadcrumbs" aria-label="Breadcrumb">
          ${this.mainTemplate()}
        </nav>
      `;
    }
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-breadcrumbs': tuftsBreadcrumbs;
  }
}
